import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix marker icons (Leaflet default bug)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const locations = [
  { name: "Mogha, Goba, Dar es Salaam", lat: -6.8209, lng: 39.2250 },
  { name: "Mtumba, Dodoma", lat: -6.1723, lng: 35.7396 },
  { name: "Mbalizi Bus Stand, Mbeya", lat: -8.9104, lng: 33.4522 },
];

export default function ContactMap() {
  return (
    <MapContainer
      center={[-6.8209, 39.2250]}
      zoom={6}
      scrollWheelZoom={false}
      style={{ height: "450px", width: "100%" }}
      className="rounded-2xl overflow-hidden"
    >
      {/* Free OpenStreetMap Tiles */}
      <TileLayer
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {locations.map((loc, index) => (
        <Marker key={index} position={[loc.lat, loc.lng]}>
          <Popup>
            <h3 className="font-bold">JIGHULUKE</h3>
            <div className="font-semibold text-sm">{loc.name}</div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
